import { Component, OnInit, Input } from '@angular/core';
import { WindowMode } from 'src/app/enums/window-mode.enum';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import swal from 'sweetalert2';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { AccountService } from 'src/app/services/account.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-virtual-office-title',
  templateUrl: './virtual-office-title.component.html',
  styleUrls: ['./virtual-office-title.component.scss']
})
export class VirtualOfficeTitleComponent implements OnInit {
  @Input() list = [];
  @Input() icon: string;
  // Modo de ventana actual
  @Input() currentWindowMode: number;
  // Lista de modos de ventana disponibles
  windowModeList = WindowMode;
  /*Otros datos */
  @Input() otherData: any;
  /*Nombre de componente padre */
  @Input() parentName: string;
  /*Indicador de navegacion*/ 
  @Input() isNavegate : boolean = false;
  bandera:boolean;
  isClient: boolean = false;
  constructor(private authService: AuthService,
     private router: Router,
    private environmentService: EnvironmentService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.bandera=this.accountService.getBandera();
    if (this.currentWindowMode == null) { this.currentWindowMode = this.windowModeList.Normal; }
    if (this.authService.getAuthToken() && !this.authService.checkIfItIsInsideIframe()) this.isClient = true;   
  }
  OutPage(){ 
    if(this.isNavegate === true){
      swal.fire({
        title: 'Aviso',
        icon: 'warning',
        text: '¿Estás seguro? Perderás todo el progreso.',
        showCancelButton: true,
        cancelButtonText: 'Volver atrás',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      }).then((result) => {
        if (result.value) {
        location.href = this.environmentService.portalWebUrl;
        }
      })
    }
    else
    {
      if (this.authService.IsStandaloneModule()) {
        window.location.reload();
        this.router.navigate(['stdln/registrar-reclamo']);
      }
      else if(this.bandera == true)
      {
        window.location.reload();   
        //window.location.href = "https://portaldev3.calidda.com.pe:8081/atencion-al-cliente/reclamos#seccion";  
              
        //Descomentar para producción
        window.location.href =  this.environmentService.portalWebUrl + "atencion-al-cliente/registrar-reclamos#seccion";  
      }
      else {
      
        this.router.navigate(['/ofivirtual']);
      }   
    }
  }
}
